import React,{useEffect} from "react";
import { useState } from "react";

//import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showMLS, setShowMLS] = useState(false);

  useEffect(() => {
    // Dynamic Import: This downloads the CSS only when the Footer mounts.
    // Replace the path below with your actual CSS location (node_modules or custom file)
    
    import('@fortawesome/fontawesome-free/css/all.min.css'); 
    // OR if you created the custom file I mentioned earlier:
    // import('../assets/css/fontawesome-custom.css'); 
    
  }, []); // Empty dependency array = runs once on mount
  return (
    <footer className="pt-5 pb-5">
      <div className="container text-center">
        <img
          src={require("../assets/image/logo/footer-logo.png")}
          alt="F.L.I. Properties"
          className="mb-4"
          style={{ maxWidth: "230px" }}
        />

        <img
          src={require("../assets/image/footer/Capture_cleanup.png")}
          alt=""
          className="mb-4"
          id="footer_bg"
        />

        <div className="row justify-content-center mb-4">
          <div className="col-auto">
            <Link to="https://movingtohappy.net/#/app/community-list" className="text-white text-decoration-none mx-2">
              Communities
            </Link>
            <Link
              to="/"
              className="text-white text-decoration-none mx-2"
            >
              Homes
            </Link>
            <Link
              to="https://movingtohappy.net/#/app/find-your-happy"
              className="text-white text-decoration-none mx-2"
            >
              FIND Your Happy
            </Link>
            <Link
              to="/builders"
              className="text-white text-decoration-none mx-2"
            >
                BUILD
            </Link>
            {/*<Link
              to="/"
              className="text-white text-decoration-none mx-2"
            >
              Rentals
            </Link>
            <Link
              to="/"
              className="text-white text-decoration-none mx-2"
            >
              Contact
            </Link>*/}
          </div>
        </div>

        <div className="mb-4">
          <a href="https://www.facebook.com/FLIproperties" className="text-white mx-2 fs-5">
            <i className="fab fa-facebook"></i>
          </a>

          <a href="https://www.instagram.com/fliproperties" className="text-white mx-2 fs-5">
            <i className="fab fa-instagram"></i>
          </a>
        </div>

        <div className="row justify-content-center small text-white-50 mb-2">
          <div className="col-auto">
            <a href="#" className="text-white text-decoration-none mx-2">
              Privacy Notice
            </a>

            <a href="#" className="text-white text-decoration-none mx-2">
              Terms of Use
            </a>

            <a href="#" className="text-white text-decoration-none mx-2">
              Do Not Share My Personal Info
            </a>

            <a href="#" className="text-white text-decoration-none mx-2">
              Cookie Preferences
            </a>
          </div>
        </div>

        <p className="small text-white mb-4">
          &copy; {currentYear} F.L.I. Properties. All rights reserved.
        </p>

        <hr className="border-secondary" />

        <p className="text-center text-white pt-3">
          Images Copyright © Deposit Photos and Shutterstock
          <br />
          This data is deemed reliable, but not guaranteed. Buyers and renters
          are strongly advised to do their own <br />
          independent research on schools, school district, school ratings and
          lifestyle related criteria
          <br />
          <br />
          {/* Search by School, School District, School Ratings brought to you by{" "}
          <br />
          ATTOM Data Solutions - Copyright © ATTOM Data Solutions
          <br />
          Sun Score is provided by SunNumber © 2025 */}
        </p>
            <p className="text-white-50 small">
  <button
  className={`btn btn-link p-0 ms-1 text-white setShowMLS ${
    showMLS ? "up" : "down"
  }`}
  onClick={() => setShowMLS(prev => !prev)}
>
    {showMLS ? "MLS Sources" : "MLS Sources"} <i class="fa fa-angle-down"></i>
  </button>
</p>
{showMLS && (
        <>
        <div className="row justify-content-center text-white-50 small text-start">
          <div className="col-md-2" id="footer_logo">
            <div className="d-flex flex-wrap justify-content-start align-items-start gap-4 my-3">
              <img
                src={require("../assets/image/footer/footer-logo-1.png")}
                style={{ height: "40px" }}
                alt="Georgia MLS"
                id="MLS"
              />
            </div>{" "}
          </div>

          <div className="col-md-10">
            <p className="pt-3  text-white">
              The data relating to real estate for sale on this web site comes
              in part from the Broker Reciprocity Program of Georgia MLS. Real
              estate listings held by brokerage firms other than F.L.I.
              Properties are marked with the Broker Reciprocity logo and
              detailed information about them includes the name of the listing
              brokers. Copyright {currentYear} Georgia MLS. All rights reserved.
              Information deemed reliable but not guaranteed.
              <br />
              <br />
            </p>
          </div>
        </div>

        <div className="row justify-content-center text-white-50 small text-start">
          <div className="col-md-2" id="footer_logo">
            <div className="d-flex flex-wrap justify-content-start align-items-start gap-4 my-3">
              <img
                src={require("../assets/image/footer/footer-logo-2.png")}
                style={{ height: "40px" }}
                alt="Columbus MLS"
              />
            </div>{" "}
          </div>

          <div className="col-md-10">
            <p className=" text-white">
              Copyright © {currentYear} Columbus Board of Realtors (GA). All rights
              reserved. All information provided by the listing agent/broker is
              deemed reliable but is not guaranteed and should be independently
              verified. Information being provided is for consumers' personal,
              non-commercial use and may not be used for any purpose other than
              to identify prospective properties consumers may be interested in
              purchasing.
              <br />
              <br />
            </p>
          </div>
        </div>

        <div className="row justify-content-center text-white-50 small text-start">
          <div className="col-md-2" id="footer_logo">
            <div className="d-flex flex-wrap justify-content-start align-items-start gap-4 my-3">
              <img
                src={require("../assets/image/footer/footer-logo-3.png")}
                style={{ height: "40px" }}
                alt="LCAR"
                id="LCAR"
              />
            </div>{" "}
          </div>

          <div className="col-md-10">
            <p className="  text-white">
              All information deemed reliable but not guaranteed. All properties
              are subject to prior sale, change or withdrawal. Neither listing
              broker(s) or information provider(s) shall be responsible for any
              typographical errors, misinformation, misprints and shall be held
              totally harmless. Listing(s) information is provided for consumers
              personal, non-commercial use and may not be used for any purpose
              other than to identify prospective properties consumers may be
              interested in purchasing. Information on this site was last
              updated as of the date posted below. The data relating to real
              estate for sale on this website comes in part from the Internet
              Data Exchange program of the Lee County Association of REALTORS®.
              All rights reserved.
              <br />
              <br />
            </p>
          </div>
        </div>

        <div className="row justify-content-center text-white-50 small text-start">
          <div className="col-md-2" id="footer_logo">
            <div className="d-flex flex-wrap justify-content-start align-items-start gap-4 my-3">
              <img
                src={require("../assets/image/footer/footer-logo-4.png")}
                style={{ height: "30px" }}

                alt="FMLS"
                id="FMLS"
              />
            </div>
          </div>

          <div className="col-md-10">
            <p className=" text-white">
              Listings identified with the FMLS IDX logo come from FMLS and are
              held by brokerage firms other than the owner of this website. The
              listing brokerage is identified in any listing details.
              Information is deemed reliable but is not guaranteed. If you
              believe any FMLS listing contains material that infringes your
              copyrighted work please <a href="#" className="text-white FooterLinkTxt">click here</a> to review our DMCA policy and
              learn how to submit a takedown request. © {currentYear} First Multiple
              Listing Service, Inc.
              <br />
              <br />
            </p>
          </div>
        </div>

        <div className="row justify-content-center text-white-50 small text-start">
          <div className="col-md-2" id="footer_logo">
            <div className="d-flex flex-wrap justify-content-start align-items-start gap-4 my-3">
              <img
                src={require("../assets/image/footer/footer-logo-5.png")}
                style={{ height: "40px" }}
                alt="GALMLS"
                id="GALMLS"
              />
            </div>
          </div>

          <div className="col-md-10">
            <p className="text-white">
              The data relating to real estate for sale on this website comes in part from the Internet Data Exchange (IDX) program of the Greater Alabama Multiple Listing Service (GALMLS). Listings held by brokerage firms other than the website owner are marked with the GALMLS IDX logo and include the name of the listing broker.
            </p>
             <p className="text-white">
              All information is deemed reliable but is not guaranteed and should be independently verified. All properties are subject to prior sale, change, or withdrawal. Neither the listing broker(s), GALMLS, nor the website owner shall be held responsible for any typographical errors, misinformation, or misprints.
            </p>
             <p className="text-white">
              The information being provided is for consumers’ personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing.
            </p>
             <p className="text-white">
              © {currentYear} Greater Alabama MLS. All rights reserved.
            </p>
            <br />
            <br />
          </div>
        </div>

        <div className="row justify-content-center text-white-50 small text-start">
          <div className="col-md-2" id="footer_logo">
            <div className="d-flex flex-wrap justify-content-start align-items-start gap-4 my-3">
              <img
                src={require("../assets/image/footer/Capture2.png")}
                style={{ height: "40px" }}
                alt="Broker Reciprocity"
                id="Reciprocity"
              />
            </div>
          </div>

          <div className="col-md-10">
            <p className="  text-white">
              The data relating to real estate for sale on this website comes
              from the Baldwin County Association Of REALTORS®. The information
              being provided is for consumers' personal, non-commercial use and
              may not be used for any purpose other than to identify prospective
              properties consumers may be interested in purchasing. Information
              deemed reliable but not guaranteed.
            </p>

           
          </div>

         
        </div>
        </>
        )}  
          <div
              className="col-12"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontFamily:'Montserrat',
                fontSize: "13px",
                fontWeight: "200",
                paddingTop: "20px",
              }}
            >
              <i
                className="fas fa-house-user"
                style={{
                  fontSize: "22px",
                  marginRight: "10px",
                  border: "none",
                }}
              ></i>
              Equal Housing Opportunity. We do business in accordance with the
              Federal Fair Housing Law
            </div>
      </div>
    </footer>
  );
};

export default Footer;
